var map = {
	"./document-placeholder.png": 60255,
	"./driving_license.png": 46019,
	"./how-can-i-access.png": 59916,
	"./how-long-do-we-keep.png": 68750,
	"./id_card.png": 12066,
	"./passport.png": 254,
	"./sedicii-logo.png": 42158,
	"./what-do-we-do.png": 72735,
	"./what-info.png": 48229,
	"./who-might-we-share.png": 77169,
	"./why-do-we-collect.png": 19846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62419;